import React from 'react'
import OrderStep from "./OrderStep";
import {Button, Container,Input, Form} from 'semantic-ui-react';
import BillCard from "./bill-card";

function OrderInvoiceDetail(props){


    return (
        <React.Fragment>
            <Form widths='equal'>
                <Form.Field
                    control={Input}
                    label='Kurum'
                    value={props.invoice.corpName}
                    name="corpName"
                />

                <Form.Field
                    control={Input}
                    label='Abone No'
                    value={props.invoice.subscriberNo}
                    name="subscriberNo"
                />
            </Form>
            <br/>
            <br/>
            <Button onClick={props.next}>Devam</Button>
            <Button onClick={props.close} floated='right' >Vazgeç</Button>
        </React.Fragment>
    )


}

export default OrderInvoiceDetail;